import { SITE, waLink } from "@/siteConfig";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

export const Footer = ({ onLead }) => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-[#1A2A24] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row md:items-end justify-between gap-10">
        <div>
          <div className="flex items-center gap-4">
            <img
              src="/logo-mark.png"
              alt="Novare Estates monogram"
              className="h-12 w-12 md:h-14 md:w-14"
            />
            <p className="font-display text-2xl md:text-3xl tracking-tight text-[#EDE7DA]">
              NOVARE ESTATES
            </p>
          </div>
          <p className="font-mono-label text-[10px] tracking-[0.3em] uppercase text-[#B8894B] mt-3">
            {t("ft.bio")}
          </p>
        </div>
        <div className="flex flex-col md:items-end gap-3">
          <button
            type="button"
            data-testid="footer-whatsapp-link"
            onClick={onLead}
            className="font-mono-label text-[11px] tracking-[0.2em] uppercase text-[#EDE7DA]/70 hover:text-[#B8894B] transition-colors duration-300 text-left md:text-right"
          >
            {t("ft.wa")}
          </button>
          <span className="font-mono-label text-[11px] tracking-[0.2em] uppercase text-[#EDE7DA]/40">
            {SITE.city}
          </span>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-12 pt-8 border-t border-[#1A2A24] flex flex-wrap items-center justify-between gap-4">
        <p className="font-mono-label text-[10px] tracking-[0.2em] uppercase text-[#EDE7DA]/35">
          {t("ft.copy")}
        </p>
        <Link
          to="/institutional"
          data-testid="footer-institutional-link"
          className="font-mono-label text-[10px] tracking-[0.2em] uppercase text-[#EDE7DA]/35 hover:text-[#B8894B] transition-colors duration-300"
        >
          {t("ft.inst")} →
        </Link>
      </div>
    </footer>
  );
};
